export type {
  QuickSearchResult,
  QuickSearchResultKind,
  QuickSearchResultType,
  QuickSearchResponse,
} from '../../../shared/search/quick-search.types';

import type { QuickSearchResult } from '../../../shared/search/quick-search.types';

/** Registry-only row shape (Phase 1 pages/tools/config). */
export type QuickSearchRegistryResult = QuickSearchResult & {
  source: 'registry';
  keywords: string[];
};

export const QUICK_SEARCH_NAV_GROUP_ORDER = ['Pages', 'Tools', 'Configuration'] as const;

export const QUICK_SEARCH_ENTITY_GROUP_ORDER = ['Sites', 'Dealers', 'Contacts', 'SOPs', 'Reports'] as const;

export const QUICK_SEARCH_GROUP_ORDER = [
  ...QUICK_SEARCH_NAV_GROUP_ORDER,
  ...QUICK_SEARCH_ENTITY_GROUP_ORDER,
] as const;

export type QuickSearchGroup = (typeof QUICK_SEARCH_GROUP_ORDER)[number];
